const PHONE_REGEXP = /^[+]?[-\s/.0-9]*(\([-\s/.0-9]+\))?[-\s/.0-9]*$/;

const phone = (message) => (value) => (!value || PHONE_REGEXP.test(value) ? null : message);

export default phone;
